<template>
  <div class="step2">
    <separate :style="{ height: '10px' }" />
    <van-cell-group inset class="cellBox">
      <van-field
        v-for="(item, i) in list.slice(0, -1)"
        :key="i"
        :model-value="dealValue(item.value, i)"
        :placeholder="item.placeholder"
        :right-icon="item.icon"
        :disabled="item?.disable"
        :required="true"
        @update:model-value="(val) => inputUpdate(i, val)"
        @click-right-icon="() => item.fn()"
        @click-input="() => item.fn()"
      />
      <Line />
    </van-cell-group>
    <div class="uploadBox">
      <p class="title">{{ lang('上传凭证') }}</p>
      <div class="imageBox">
        <div v-if="!image" class="uploadOperate" @click="upLoad">
          <small-loading v-if="loadingImage" />
          <template v-else>
            <img src="@/assets/images/score/camera.png" />
            <p>{{ lang('上传凭证图片') }}</p>
          </template>
        </div>
        <div v-else class="uploadOperate uploadImage">
          <img
            :src="image"
            style="width: 100%; height: 100%; border-radius: 3px"
          />
          <div class="delete" @click="deleteImage">
            <p>{{ lang('删除') }}</p>
          </div>
        </div>
        <div class="rightImage">
          <p class="rightName">
            {{ lang('请上传如图所示的银行汇款回单照片') }}
          </p>
          <img src="@/assets/images/score/example.png" />
        </div>
      </div>
    </div>

    <van-popup
      v-model:show="show"
      round
      position="bottom"
      class="time"
      :style="{ height: '50%' }"
    >
      <van-picker-group
        :title="lang('预约日期')"
        :tabs="[lang('选择日期'), lang('选择时间')]"
        :confirm-button-text="lang('确定')"
        :cancel-button-text="lang('取消')"
        @confirm="onConfirm"
        @cancel="onCancel"
      >
        <van-date-picker v-model="currentDate" :min-date="minDate" />
        <van-time-picker v-model="currentTime" />
      </van-picker-group>
    </van-popup>
    <van-popup
      v-model:show="showBank"
      class="bank"
      destroy-on-close
      round
      position="bottom"
    >
      <van-picker
        :model-value="pickerValue"
        :columns="columns"
        :confirm-button-text="lang('确定')"
        :cancel-button-text="lang('取消')"
        :title="lang('银行列表')"
        @cancel="showBank = false"
        @confirm="confirmBank"
      />
    </van-popup>
  </div>
</template>

<script lang="ts" setup>
import Separate from '@core/components/separate.vue'
import { onMounted, ref, watch } from 'vue'
import Line from '@core/components/line.vue'
import { getPhoto } from '@core/utils/nativeAPI'
import { bankList, Remittance } from '@/api/requests/score'
import { showToast } from 'vant'
import { RemittanceReq } from '@/model/score/score'
import { uploadFile } from '@/utils/imageUpload'
import SmallLoading from '@core/components/smallLoading.vue'
import { getFormattedDate } from '@core/utils/aboutDate'
import lang from '@/langs'
import dayjs from 'dayjs'
const show = ref(false)
const columns = ref([])
const fieldValue = ref('')
const showBank = ref(false)
const pickerValue = ref<number[]>([])
const currentDate = ref(getFormattedDate())
const currentTime = ref(getCurrentHourAndMinute())
const image = ref('')
const loadingImage = ref(false)
const list = ref([
  {
    placeholder: lang('请选择汇款银行'),
    value: '',
    icon: 'arrow',
    disable: true,
    fn: () => selectBank()
  },
  {
    placeholder: lang('请输入汇款银行账户'),
    value: '',
    icon: '',
    fn: () => {}
  },
  {
    placeholder: lang('请输入汇款人姓名'),
    value: '',
    icon: '',
    fn: () => {}
  },
  {
    placeholder: lang('充值金额:0.01~50000.00'),
    value: '',
    icon: '',
    fn: () => {}
  },
  {
    placeholder: lang('请选择实际汇款时间'),
    value: '',
    icon: 'arrow',
    disable: true,
    fn: () => selectTime()
  },
  {
    placeholder: lang('收据'),
    value: '',
    hidden: true,
    fn: () => {}
  }
])
const inputUpdate = (i: number, value: string) => {
  list.value[i].value = value
}
const dealValue = (value: string, i: number) => {
  if (!value) {
    return ''
  }
  if (i === 4) {
    return value.slice(0, -3)
  }
  return value
}
const emits = defineEmits(['finish'])
const deleteImage = () => {
  image.value = ''
  list.value[5].value = ''
}
const updateParam = () => ({
  applyAmount: list.value[3].value,
  applyName: list.value[2].value,
  bankAccount: list.value[1].value,
  remittanceDate:
    currentDate.value.join('-') + ' ' + currentTime.value.join(':') + ':00'
})
const param = ref<RemittanceReq>({
  applyAmount: list.value[3].value,
  applyName: list.value[2].value,
  bankAccount: list.value[1].value,
  bankId: '',
  bankName: '',
  remittanceDate:
    currentDate.value.join('-') + ' ' + currentTime.value.join(':') + ':00',
  voucher: ''
})
function getCurrentHourAndMinute(): [hour: string, minute: string] {
  const now = new Date()
  const hour = now.getHours().toString().padStart(2, '0')
  const minute = now.getMinutes().toString().padStart(2, '0')
  return [hour, minute]
}
const selectBank = () => {
  showBank.value = true
}
const confirmBank = (value) => {
  showBank.value = false
  list.value[0].value = value.selectedOptions[0].text
  param.value.bankName = value.selectedOptions[0].text
  param.value.bankId = value.selectedOptions[0].value
}
const selectTime = () => {
  show.value = true
}
const minDate = ref(new Date(2020, 0, 1))
// const maxDate = ref(new Date(2025, 5, 1))
const active = ref(0)
const onConfirm = () => {
  const temp =
    currentDate.value.join('-') + ' ' + currentTime.value.join(':') + ':00'

  list.value[4].value = dayjs(temp).format('YYYY-MM-DD HH:mm:ss')
  currentDate.value.join('-') + ' ' + currentTime.value.join(':') + ':00'
  show.value = false
}
const upLoad = () => {
  getPhoto().then((value) => {
    const temp = JSON.parse(value)
    uploadFile(
      temp[0].data,
      temp[0].name,
      (res, data) => {
        if (res) {
          showToast(lang('上传成功'))
          console.log(data?.path)
          param.value.voucher = data?.path || ''
          image.value = data?.url || ''
          list.value[5].value = data?.path || ''
        } else {
          showToast(lang('上传失败'))
        }
      },
      (loading) => {
        loadingImage.value = loading
      }
    )
  })
}
const onCancel = () => {
  show.value = false
}
const getBankList = () => {
  bankList().then((value) => {
    if (value.code === 1) {
      columns.value =
        value?.data?.records.map((item, i) => {
          return { value: item.id, text: item.dictValue }
        }) || []
    } else {
      showToast(lang(value?.msg) || 'Service exception, please try again later')
    }
  })
}
const isAllFilled = ref(false)
watch(
  list.value,
  (value) => {
    param.value = { ...param.value, ...updateParam() }
    isAllFilled.value = list.value.every((item) => item.value.trim() !== '')
  },
  {
    deep: true
  }
)
watch([isAllFilled, param], ([isFilledValue, paramValue]) => {
  emits('finish', paramValue, isFilledValue)
})

onMounted(() => {
  getBankList()
})
</script>

<style scoped lang="less">
.step2 {
  :deep(.van-cell-group) {
    .van-cell {
      .van-field__control:disabled {
        -webkit-text-fill-color: rgba(60, 60, 60, 1);
      }
      .van-field__control::placeholder {
        -webkit-text-fill-color: rgba(183, 183, 183, 1);
      }
    }
  }
  .cellBox {
    margin: 0;
    :deep(.van-field) {
      padding: 18px 16px;
      .van-icon {
        color: rgba(183, 183, 183, 1);
      }
    }
  }
  .uploadBox {
    background: #fff;
    padding: 18px 16px;
    .title {
      margin-bottom: 13px;
      color: rgba(60, 60, 60, 1);
      font-size: 14px;
    }
    .imageBox {
      display: flex;
      flex-direction: row;
      height: 125px;
      .uploadOperate {
        width: 55%;
        position: relative;
        background: rgba(247, 247, 247, 1);
        border-radius: 3px;
        margin-right: 25px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        max-width: 200px;
        > p {
          font-size: 12px;
          color: rgba(183, 183, 183, 1);
          margin-top: 11px;
        }
        > img {
          width: 18px;
          height: 18px;
        }
      }
      .uploadImage {
        .delete {
          background: rgba(16, 15, 15, 0.6);
          position: absolute;
          bottom: 0;
          width: 100%;
          text-align: center;
          padding: 5px;
          > p {
            font-size: 14px;
            color: rgba(241, 236, 236, 0.7);
          }
        }
      }
      .rightImage {
        flex: 1;
        display: flex;
        flex-direction: column;
        .rightName {
          color: rgba(153, 153, 153, 1);
          font-size: 14px;
          margin-bottom: 18px;
        }
        > img {
          width: 54px;
          //aspect-ratio: 9/16;
        }
      }
    }
  }
  .bank {
    :deep(.van-picker) {
      .van-picker__confirm {
        color: rgba(255, 0, 0, 1);
      }
    }
  }
  .time {
    :deep(.van-picker-group) {
      .van-picker__confirm {
        color: rgba(255, 0, 0, 1);
      }
      .van-tabs {
        .van-tabs__wrap {
          .van-tabs__nav {
            .van-tabs__line {
              background: rgba(255, 0, 0, 1);
            }
          }
        }
      }
    }
  }
}
</style>
